import {useQuery} from "react-query";
import {getQR} from "../service/DigitalMenu";

export const useQr = (restaurantId) => {
    return useQuery({
        queryKey: ['get-qr', restaurantId],
        queryFn: () => getQR(restaurantId).then((response) => response.data),
        enabled: !!restaurantId
    })
}